module.exports = __webpack_public_path__ + "images/botenwacht_small4b0a2db57a20363b660de4dc164d7a69.png";